const dataOffersFrFr = [
  {
    offer: 'links',
    children: [
      {
        id: 'state-of-services',
        text: 'États des services',
        linkTitle: 'États des services',
      },
      {
        id: 'legal-information',
        text: 'Informations légales',
        linkTitle: 'Informations légales',
      },
      {
        id: 'rc-cc',
        text: 'Conditions contractuelles',
        linkTitle: 'Conditions contractuelles',
      },
      {
        id: 'manage-cookies',
        text: 'Gérer les cookies',
        linkTitle: 'Gérer les cookies',
      },
    ],
  },
];

export default dataOffersFrFr;
